module.exports = __webpack_public_path__ + "img/deskshelf01.fe18b130.jpg";